<app-form-view
  [submitSuccess]="submitSuccess()"
  [submitError]="submitError()"
  (formSubmit)="submit($event)"
  (caseNumber)="caseNumber()"
  [isSubmittingInProgress]="isSubmittingInProgress()"
  [keyClientList]="keyClientList"
  [claimTypesList]="claimTypesList"
  [accomodationRequirementList]="accomodationRequirementList"
  >/>
</app-form-view>
